module.exports = __webpack_public_path__ + "img/twitch.8a7c417f.png";